<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      :disabled="disabled"
      size="mini"
    >
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            :label="$l('batch_label_deliveryDate') || '工厂交期'"
            prop="deliveryDate"
          >
            <el-date-picker
              v-model="formData.deliveryDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('tips_batch_label_deliveryDate') || '请选择工厂交期'
              "
              style="width: 100%"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('batch_label_shipmentDate') || '客户交期'"
            prop="shipmentDate"
          >
            <el-date-picker
              v-model="formData.shipmentDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('tips_batch_label_shipmentDate') || '请选择客户交期'
              "
              style="width: 100%"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('batch_label_shipmentEndDate') || '客户交期截止日期'"
            prop="shipmentEndDate"
          >
            <el-date-picker
              v-model="formData.shipmentEndDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('tips_batch_label_shipmentEndDate') ||
                  '请选择客户交期截止日期'
              "
              style="width: 100%"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            :label="$l('INDEX.form_label_cargoReadyDay') || '货好时间'"
            prop="cargoReadyDay"
          >
            <el-date-picker
              v-model="formData.cargoReadyDay"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('INDEX.form_label_please_select_cargoReadyDay') ||
                  '请选择货好时间'
              "
              style="width: 100%"
              clearable
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="5">
          <el-form-item :label="$l('batch_label_deliveryType') || '出货方式'">
            <dict-select
              v-model="formData.deliveryType"
              :body="deliveryTypeParams"
              url="/master/common/dict/biz"
              :placeholder="
                $l('tips_batch_label_deliveryType') || '请选择出货方式'
              "
              size="mini"
              clearable
              filterable
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item :label="$l('batch_label_outBillType') || '出单类型'">
            <dict-select
              v-model="formData.outBillType"
              url="/master/common/dict/biz"
              :body="outBillTypeParams"
              :placeholder="
                $l('tips_batch_label_outBillType') || '请选择出单类型'
              "
              size="mini"
              filterable
              clearable
              :disabled="isDomesticTrade"
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            :label="$l('batch_label_dispatchPort') || '发运港口'"
            prop="dispatchPort"
          >
            <dict-select
              v-model="formData.dispatchPort"
              url="/master/port/select"
              :placeholder="
                $l('tips_batch_label_dispatchPort') || '请选择发运港口'
              "
              size="mini"
              clearable
              filterable
              :disabled="isDomesticTrade"
            >
            </dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="7">
          <el-form-item
            :label="$l('batch_label_destinationPort') || '目的港口'"
            prop="destinationPort"
          >
            <dict-select
              v-model="formData.destinationPort"
              url="/master/port/select"
              :placeholder="
                $l('tips_batch_label_destinationPort') || '请选择目的港口'
              "
              :selectedLabel.sync="formData.destinationPortName"
              size="mini"
              clearable
              filterable
              :disabled="isDomesticTrade"
            >
            </dict-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="4">
          <el-form-item
            :label="$l('INDEX.form_label_brand') || '品牌'"
            prop="brandCode"
          >
            <dict-select
              clearable
              v-model="formData.brandCode"
              filterable
              url="/master/common/dict/brandSelect"
              :placeholder="
                $l('INDEX.form_label_please_select_brand') || '请选择品牌'
              "
              size="mini"
              style="width:100%"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('INDEX.order_form_label_retailerPo') || '零售商PO'"
            prop="retailerPo"
          >
            <el-input
              v-model="formData.retailerPo"
              :placeholder="
                $l('INDEX.order_tips_input_retailerPo') || '请输入零售商PO'
              "
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('INDEX.order_form_label_importerPo') || '代理商PO'"
            prop="importerPo"
          >
            <el-input
              v-model="formData.importerPo"
              :placeholder="
                $l('INDEX.order_tips_input_importerPo') || '请输入代理商PO'
              "
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="10">
          <el-form-item :label="$l('batch_label_identifyNo') || '批次识别单号'">
            <identify-input
              size="mini"
              :disabled="disabled"
              :identifyNo.sync="formData.identifyNo"
              :identifyJson.sync="formData.identifyJson"
              :placeholder="'请选择批次识别单号'"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="24"> </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item :label="$l('INDEX.tab_demand_packing') || '装箱方案'">
            <el-input clearable v-model="formData.displayFieldOne" readonly>
              <el-button
                slot="append"
                icon="el-icon-finished"
                @click="openOrderPackingDialog"
              ></el-button>
            </el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('total_of_batch') || '批次总数'">
            <el-input v-model="formData.totQty" readonly></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('total_boxes_of_batch') || '批次总箱数'">
            <el-input
              v-if="formData.packingType != 'B'"
              v-model="formData.totBoxQty"
              readonly
            ></el-input>
            <el-input-number
              v-if="formData.packingType === 'B'"
              v-model="formData.totBoxQty"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              controls-position="right"
              :min="0"
              :step="1"
              style="width:100%"
              @change="updateTotBoxQty"
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <el-form-item :label="$l('form_label_materCarton') || '纸板箱数'">
            <el-input-number
              v-model="formData.materCarton"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
              controls-position="right"
              :min="0"
              :step="1"
              style="width:100%"
            >
            </el-input-number>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="24">
          <div>
            <span>
              {{ $l('tab_demand_package') || '外包装箱' }} ：
              {{
                formData.displayFieldTwo ? formData.displayFieldTwo : '--'
              }}</span
            >
          </div>
        </el-col>
      </el-row>
      <ShippingMark
        class="mt-2"
        ref="shippingMark"
        size="mini"
        :disabled="disabled"
        :shippingMarkType.sync="formData.shippingMarkType"
        :shippingMarkText.sync="formData.shippingMarkText"
        :shippingMarkImageUrl.sync="formData.shippingMarkImageUrl"
        :shippingMarkImageFileCode.sync="formData.shippingMarkImageFileCode"
        :shippingMarkCode.sync="formData.shippingMarkCode"
        :custCode="custCode"
        :destinationPort="formData.destinationPort"
      />
      <GoodsTable
        class="mt-2"
        ref="goodsTable"
        :tableData="formData.listGoods"
        :orderBatchCode="orderBatchCode"
        :packingType="formData.packingType"
        :disabled="disabled"
        @change="goodsChange"
      />

      <ChooseDemandPackingDialog
        :title="$l('choose_tab_demand_packing') || '选择装箱方案'"
        :visible.sync="orderPackingDialogVisible"
        :orderCode="orderCode"
        @confirm="choosePackingConfirm"
      />
    </el-form>
    <el-dialog
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
      :modal-append-to-body="false"
      :modal="false"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="mini">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="mini">
          {{ $l('INDEX.btn_no_save') || '不保存' }}</el-button
        >
        <el-button @click="save()" type="primary" size="mini">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import GoodsTable from '../goods-table'
import ChooseDemandPackingDialog from '../choose-demand-packing/dialog.vue'
import ShippingMark from '../shippingmark'
import EditLoading from '@/mixins/edit-loading'
import { add, divideDown } from '@/libs/util.number.js'
export default {
  mixins: [EditLoading],
  components: { GoodsTable, ChooseDemandPackingDialog, ShippingMark },
  props: {
    orderBatchCode: { type: String, default: '' },
    orderCode: { type: String, default: '' },
    optType: { type: String, default: '' },
    orderType: { type: String, default: '' },
    custCode: { type: String, default: '' },
  },
  data() {
    return {
      deliveryTypeParams: { dictType: 'deliveryType' },
      outBillTypeParams: { dictType: 'outBillType' },
      backDialogVisible: false,
      orderPackingDialogVisible: false,
      formData: { totQty: 0, totBoxQty: 0, packingType: '' },
      rules: {
        deliveryDate: [
          {
            required: true,
            message:
              this.$l('tips_batch_label_deliveryDate') || '请输入工厂交期',
            trigger: 'change',
          },
        ],
        shipmentDate: [
          {
            required: true,
            message:
              this.$l('tips_batch_label_shipmentDate') || '请输入客户交期',
            trigger: 'change',
          },
        ],
        shipmentEndDate: [
          {
            required: true,
            message:
              this.$l('tips_batch_label_shipmentEndDate') ||
              '请选择客户交期截止日期',
            trigger: 'change',
          },
        ],
        cargoReadyDay: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_please_select_cargoReadyDay') ||
              '请选择货好时间',
            trigger: 'change',
          },
        ],
        deliveryType: [
          {
            required: true,
            message:
              this.$l('tips_batch_label_deliveryType') || '请选择出货方式',
            trigger: 'change',
          },
        ],
        brandCode: [
          {
            required: true,
            message:
              this.$l('INDEX.form_label_please_select_brand') || '请选择品牌',
            trigger: ' change',
          },
        ],
      },
    }
  },
  computed: {
    isCopy() {
      return this.optType === 'copy'
    },
    disabled() {
      return this.optType === 'detail'
    },
    isDomesticTrade() {
      return this.orderType === 'domesticTrade'
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    async getData() {
      if (!this.orderBatchCode) return
      const res = await this.$api
        .orderBatchDetailApi({
          orderBatchCode: this.orderBatchCode,
        })
        .catch(() => null)
      if (!res) return
      const data = res.body

      this.formData = data
      if (this.isCopy) {
        this.formData.orderBatchCode = ''
        this.formData.identifyNo = ''
        this.formData.identifyJson = ''
      }

      const {
        materialNo,
        materialDisplayName,
        materialSpec,
        v_packingType,
        v_outBillType,
      } = data

      this.formData.displayFieldOne = `${v_packingType} ${v_outBillType}`
      this.formData.displayFieldTwo = `${materialNo} | ${materialDisplayName} | ${materialSpec}`
    },
    async formValidate() {
      const formResult = await validate.formValidate([this.$refs.formData])
      const goodsResult = this.$refs.goodsTable.validate()
      return formResult && goodsResult
    },
    async save() {
      if (!(await this.formValidate())) return (this.backDialogVisible = false)

      const deliveryDate = new Date(this.formData.deliveryDate).getTime() //工厂交期
      const shipmentDate = new Date(this.formData.shipmentDate).getTime() //客户交期
      const shipmentEndDate = new Date(this.formData.shipmentEndDate).getTime() //客户截至交期
      const cargoReadyDay = new Date(this.formData.cargoReadyDay).getTime() //货好时间
      let message = []
      message.push(
        shipmentEndDate < shipmentDate
          ? this.$l('INDEX.tips_shipment_end_than_shipment_date') ||
              '客户交期截止日期，不能小于 客户交期'
          : ''
      )
      message.push(
        shipmentEndDate < deliveryDate
          ? this.$l('INDEX.tips_delivery_date_less_than_customer_comfirm') ||
              '工厂交期，不能大于 客户交期截止日期'
          : ''
      )
      message.push(
        shipmentEndDate < cargoReadyDay
          ? this.$l('INDEX.tips_cargoReadyDay_less_than_customer_comfirm') ||
              '货好时间，不能大于 客户交期截止日期'
          : ''
      )
      message = message.filter(Boolean)
      if (message.length) {
        this.$confirm(
          message.join('<br />'),
          this.$l('INDEX.tips_question_title') || '提示信息',
          {
            confirmButtonText: this.$l('INDEX.btn_confirm') || '确定',
            cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
            type: 'warning',
            showCancelButton: false,
            dangerouslyUseHTMLString: true,
          }
        )
        return
      }

      const listGoods = await this.$refs.goodsTable.getTableData()
      if (!listGoods || !listGoods.length) {
        return this.$message.warning('请添加产品信息')
      }

      const _totQty = listGoods
        .map(({ qty }) => qty)
        .reduce((a, b) => add(a, b), 0)
      const { totQty } = this.formData

      if (_totQty !== totQty) {
        this.formData.totQty = _totQty
        const message = `批次总数<span style="color: #409eff;">${totQty}</span>与产品总数<span style="color: #409eff;">${_totQty}</span>不一致。<br />已重新计算批次总数！`
        await this.$alert(`${message}`, '确认信息', {
          dangerouslyUseHTMLString: true,
        })
          .then(() => true)
          .catch(() => false)
        return false
      }

      if (this.loadingOpen()) return
      const res = await this.$api
        .orderBatchSaveApi({
          ...this.formData,
          orderCode: this.orderCode,
          listGoods,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_save_ok') || '保存成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      if (this.disabled) {
        this.close()
        return
      }
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    async choosePackingConfirm(data) {
      if (!data) return
      const {
        materialNo,
        totBoxQty,
        materialName,
        materialDisplayName,
        materialSpec,
        orderPackingCode,
        v_packingType,
        v_outBillType,
        orderGoodsCodeList,
      } = data

      this.formData.materialNo = materialNo
      this.formData.materialName = materialName
      this.formData.orderPackingCode = orderPackingCode
      this.formData.displayFieldOne = `${v_packingType} ${v_outBillType}`
      this.formData.displayFieldTwo = `${materialNo} | ${materialDisplayName} | ${materialSpec}`

      if (this.loadingOpen()) return
      const res = await this.$api
        .addBatchGoodsByPackingCodeApi({
          orderCode: this.orderCode,
          orderPackingCode,
          orderGoodsCodeList,
          totBoxQty,
        })
        .catch(() => null)
      this.loadingClose()
      if (!res) return

      const {
        packingType: resPackingType,
        totQty: resTotQty,
        totBoxQty: resTotBoxQty,
        listGoods,
      } = res.body

      this.formData.packingType = resPackingType
      this.formData.totQty = resTotQty
      this.formData.totBoxQty = resTotBoxQty
      this.formData.listGoods = listGoods
      if (resPackingType == 'B') {
        setTimeout(() => this.updateTotBoxQty(resTotBoxQty), 0)
      }
    },
    openOrderPackingDialog() {
      if (!this.formData.orderPackingCode) {
        this.orderPackingDialogVisible = true
        return
      }

      this.$confirm(
        this.$l('Re_selecting_will_clear_product_list') ||
          '重新选择装箱方案会清空产品列表',
        this.$l('INDEX.label_completeDesc') || '确认信息',
        {
          confirmButtonText:
            this.$l('INDEX.product_dialog_btn_confirm') || '确定',
          cancelButtonText: this.$l('INDEX.btn_cancel') || '取消',
          type: 'warning',
        }
      ).then(() => {
        this.orderPackingDialogVisible = true
      })
    },
    updateTotBoxQty(boxQty) {
      this.$refs.goodsTable.updateTotBoxQty(boxQty)
    },
    goodsChange(data) {
      const { packingType, totBoxQty } = this.formData
      const totQty = (data || [])
        .map(({ qty }) => qty)
        .reduce((a, b) => add(a, b), 0)
      const _totBoxQty =
        packingType !== 'B'
          ? (data || [])
              .map(({ qty, inPackageQty }) => divideDown(qty, inPackageQty, 0))
              .reduce((a, b) => add(a, b), 0)
          : totBoxQty

      this.formData.totQty = totQty
      this.formData.totBoxQty = _totBoxQty
    },
  },
}
</script>
